// Text
export const textPrimary = "#343C43DE";
export const textSecondary = "#343C4399";
export const textDisabled = "#343C4399";

// Primary
export const primaryMain = "#1DA5C3";
export const primaryDark = "#367286";
export const primaryLight = "#8AC7D9";
export const primaryContrast = "#FFFFFF";

// Secondary
export const secondaryMain = "#748291";
export const secondaryDark = "#515C65";
export const secondaryLight = "#ACB5BD";
export const secondaryContrast = "#FFFFFF";

// Error
export const errorMain = "#D32F2F";
export const errorDark = "#C62828";
export const errorLight = "#EF5350";
export const errorContrast = "#FFFFFF";

// Warning
export const warningMain = "#EF6C00";
export const warningDark = "#E65100";
export const warningLight = "#FF9800";
export const warningContrast = "#FFFFFF";

// Info
export const infoMain = "#82B6E3";
export const infoDark = "#5C809F";
export const infoLight = "#B3D3EE";
export const infoContrast = "#FFFFFF";

// Success
export const successMain = "#80CC8D";
export const successDark = "#5A8F63";
export const successLight = "#B0E0BA";
export const successContrast = "#FFFFFF";

// Purple (scoring profile 3)
export const purpleMain = "#7C5CBF";
export const purpleDark = "#5E3F9E";
export const purpleLight = "#A98AD8";
export const purpleContrast = "#FFFFFF";

// AppBar colors
export const appBarNavItemSelected = "#0d47a1";
